import nxModule from 'nxModule';
import {BatchLoanPreterminationService, PreterminationBatchFileOutput} from './batch-loan-preterminations.service';
import {UserDetails} from '../../service/users/user.cache';
import templateUrl from './batch-loan-preterminations-history.template.html'
import {NgTableParams} from 'ng-table';
import {HttpService} from "shared/utils/httpService";
import {ReportModal} from "components/report/modal/report-modal.service.types";

interface PreterminationBatchFileView extends PreterminationBatchFileOutput {
  uploadedBy: UserDetails;
}

class BatchLoanPreterminationsHistory {
  tableConfig!: NgTableParams<PreterminationBatchFileOutput>;
  totalRowCount?: number;

  constructor(private readonly http: HttpService,
              private readonly batchLoanPreterminationService: BatchLoanPreterminationService,
              private readonly reportModal: ReportModal) { }

  async $onInit() {
    this.tableConfig = new NgTableParams({
      page: 1,
      count: 20
    }, {
      counts: [],
      total: 0,
      paginationMinBlocks: 3,
      paginationMaxBlocks: 8,
      getData: async (params: NgTableParams<PreterminationBatchFileView>) => {
        const request = {
          pageNo: params.page() - 1,
          pageSize: params.count()
        };
        const response = await this.batchLoanPreterminationService.readPreterminationBatchFilesOutput(request);
        this.totalRowCount = response.totalCount;
        params.total(this.totalRowCount);
        return response.result;
      }
    });
  }

  showDetails(preterminationBatchFileId: number): void {
    this.reportModal.display({
      params: {preterminationBatchFileId},
      reportCode: 'LoanPaymentsReportNoFilter',
      hideXls: false
    });
  }

  showErrorDetails(preterminationBatchFileId: number): void {
    this.reportModal.display({
      params: {preterminationBatchFileId},
      reportCode: 'LoanBatchPreterminationErrorsReport',
      hideXls: false
    });
  }
}

nxModule.component('batchLoanPreterminationsHistory', {
  templateUrl,
  controller: BatchLoanPreterminationsHistory,
});